/// <reference types='@runette/leaflet-fullscreen' />
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '@mottu-ops/sso';
import { KeycloakEventType, KeycloakService } from '@mottu-ops/keycloak-angular';
import { environment } from '../environments/environment';
import { VeiculoSuporte } from './shared/models/ServicoVeiculoSuporte.model';
import { UsuarioLogged } from './shared/models/Usuario.model';
import { CheckForUpdateService } from './shared/services/check-for-update.service';
import { InternalAuthService } from './shared/services/internalauth.service';
import { ObservabilityService } from './shared/services/observability.service';
import { UserAgentService } from './shared/services/user-agent.service';
import { TranslateService } from '@mottu-ops/locale';

export const SKIP_AUTH = [
  'area-atendimento',
  'fagbot',
  'formulario-pagamento',
  'formulario-previsao-chegada',
  'formulario-aceite-servico',
  'formulario-acompanhamento-servico',
  'acompanhamento-servico',
  'formulario-cadastro-terceiro',
  'assets/img/gps_blink.svg',
  'confirm-email',
  'terceiros-cadastro',
  'servico-status',
  'rastreio',
  'upload-driver-license'
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public title = 'mottu-monitor';
  public userLogged: UsuarioLogged;
  public renderRouter = false;
  public isLoggedIn = false;

  constructor(
    private internalAuthService: InternalAuthService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private keycloak: KeycloakService,
    private authService: AuthService,
    private userAgentService: UserAgentService,
    private observabilityService: ObservabilityService,
    private checkUpdateService: CheckForUpdateService,
    private translateService: TranslateService
  ) {
    this.translateService.ngxTranslateService.use(this.translateService.siteLanguage);

    this.matIconRegistry.addSvgIcon(
      'occ_guard',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/img/monitor_icone_vigia-02.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'occ_guard_black',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/img/monitor_icone_vigia-03.svg'
      )
    );

    this.userLogged = this.internalAuthService.userLogged?.dataResult;
  }

  async ngOnInit() {
    this.checkUpdateService.init();
    this.getUserAgentData();

    const url = window.location.href;
    if (SKIP_AUTH.some(skip => url.includes(skip))) {
      this.renderRouter = true;
      return;
    }
    this.isLoggedIn = this.keycloak.isLoggedIn();

    if (this.isLoggedIn) {
      const token = await this.keycloak.getToken();
      try {
        const refreshToken = await this.keycloak.getKeycloakInstance().refreshToken;
        localStorage.setItem('refreshToken', refreshToken);
      } catch {
      }

      this.authService.credentials = {
        accessToken: token,
      };

      const [userInfo, _] = await Promise.all([
        this.authService.getUserInfo(environment.keycloak),
        this.internalAuthService.authorize(),
      ]);

      this.renderRouter = true;

      this.authService.user = userInfo;

      this.observabilityService.init(userInfo);

      this.keycloak.keycloakEvents$.subscribe({
        next: async event => {
          if (event.type == KeycloakEventType.OnTokenExpired) {
            await this.updateToken();
          }
          if (
            event.type == KeycloakEventType.OnAuthRefreshError ||
            event.type == KeycloakEventType.OnAuthError ||
            event.type == KeycloakEventType.OnAuthLogout
          ) {
            await this.keycloak.login();
          }
        },
      });
    } else {
      await this.keycloak.login();
    }
  }

  private async updateToken(): Promise<void> {
    await this.keycloak.updateToken();


    const newToken = await this.keycloak.getToken();
    try {
      const refreshToken = await this.keycloak.getKeycloakInstance().refreshToken;
      localStorage.setItem('refreshToken', refreshToken);
    } catch {
    }
    this.authService.credentials = {
      ...this.authService.credentials,
      accessToken: newToken
    };
  }

  private getUserAgentData() {
    this.userAgentService.saveUserAgentToLocalStorage();
  }
}

